import type React from 'react'
import { OrganizationSearchWidget } from 'View/Component/Organization/OrganizationSearchWidget.js'

export const OrganizationSearchPage: React.FC = () => {
  return (
    <div className="bg-slate-100 rounded-lg p-4 drop-shadow-sm m-auto">
      <div className="overflow-y-auto" style={{ minWidth: 900 }}>
        <h1 className="text-2xl mb-4 pl-4 flex items-center">
          <div className="relative">Marketplace</div>
        </h1>
        <OrganizationSearchWidget pageSize={8} />
      </div>
    </div>
  )
}
